
import HTTP from '@/config/axios-config-erp'

const SrvImpresion = {

  getURLFacturas(payload) {
    return HTTP.post(`/wscomun/portalinformes/reimpresion`, payload).then(response => {
      return response
    }).catch(error => {
      console.error(error)
      return error
    })
  },
  // Llamada en la capa Java a "/informeFacturacionExpert/reimpresion"
  getZipFacturas(payload) {
    return HTTP.post(`/wscomun/wsutils/obtenerZipFacturas`, payload).then(response => {
      return response
    }).catch(error => {
      console.log(error)
      return { 'status': 500 }
    })
  },
  fRecuperarDocumentoCab(payload) {
    return HTTP.post(`/wscomun/portalinformes/recuperarDocumentoCab`, payload).then(response => {
      if (response.status === 200) {
        return response
      } else {
        console.error(response)
        return response
      }
    }).catch(error => {
      return error
    })
  },
  getDescargaProforma(payload) {
    return HTTP.post(`/wscomun/portalinformes/obtenerProforma`, payload).then(response => {
      return response
    }).catch(error => {
      console.error(error)
      return error
    })
  },
  estadisticaProvinciaRpte(payload) {
    return HTTP.post(`/wscomun/portalinformes/estadisticaProvinciaRpte`, payload).then(response => {
      return response
    }).catch(error => {
      console.error(error)
      return error
    })
  },
  ventasDelegacionRepresCliente(payload) {
    return HTTP.post(`/wscomun/portalinformes/ventasDelegacionRepresCliente`, payload).then(response => {
      return response
    }).catch(error => {
      console.error(error)
      return error
    })
  },
  informeSituacionExpert(payload) {
    return HTTP.post(`/wscomun/portalinformes/informeSituacionExpert`, payload).then(response => {
      return response
    }).catch(error => {
      console.error(error)
      return error
    })
  },
  getReportAlbaran(payload) {
    return HTTP.post(`/wscomun/portalinformes/imprimirAlbaran`, payload).then(response => {
      if (response.status === 200) {
        return response
      } else {
        console.error(response)
        return response
      }
    }).catch(error => {
      return error
    })
  },
  // PROVEEDORES
  getAlbaranProveedor(payload) {
    return HTTP.post(`/wscomun/portalinformes/getAlbaranesProveedor`, payload).then(response => {
      if (response.status === 200) {
        return response
      } else {
        console.error(response)
        return response
      }
    }).catch(error => {
      return error
    })
  },
  getReportAlbaranProv(payload) {
    return HTTP.post(`/wscomun/portalinformes/imprimirAlbaranProv`, payload).then(response => {
      if (response.status === 200) {
        return response
      } else {
        console.error(response)
        return response
      }
    }).catch(error => {
      return error
    })
  },
  imprimirFacturaCSV(payload) {
    return HTTP.post(`/wscomun/portalinformes/imprimirFacturaCSV`, payload).then(response => {
      if (response.status === 200) {
        return response
      } else {
        console.error(response)
        return response
      }
    }).catch(error => {
      return error
    })
  },
  carteraSitCobros(payload) {
    return HTTP.post(`/wscomun/portalinformes/carteraSitCobros`, payload).then(response => {
      if (response.status === 200) {
        return response
      } else {
        console.error(response)
        return response
      }
    }).catch(error => {
      return error
    })
  },
  carteraSitPagos(payload) {
    return HTTP.post(`/wscomun/portalinformes/carteraSitPagos`, payload).then(response => {
      if (response.status === 200) {
        return response
      } else {
        console.error(response)
        return response
      }
    }).catch(error => {
      return error
    })
  },
}

export default SrvImpresion



// WEBPACK FOOTER //
// ./src/services/srv-impresion.js